module.exports = __webpack_public_path__ + "img/key.4deb1409.svg";